// frontend/src/contexts/ThemeContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

// NOTE: key is "app-theme-v2" (not "app-theme") so a stale "light" preference
// saved by the OLD theme code can never override the new dark-first default.
const STORAGE_KEY = 'app-theme-v2';

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Honor a manually saved preference under the NEW key only.
    const savedTheme = localStorage.getItem(STORAGE_KEY);
    if (savedTheme === 'light' || savedTheme === 'dark') {
      return savedTheme;
    }
    // Default to the dark, premium studio theme. Light is a manual toggle only.
    return 'dark';
  });

  useEffect(() => {
    // Apply the theme to the <html> tag so Bootstrap 5.3 catches it globally.
    document.documentElement.setAttribute('data-bs-theme', theme);
    document.documentElement.style.colorScheme = theme;
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
